<script setup lang="ts">
withDefaults(
  defineProps<{
    value?: string;
    placeholder?: string;
  }>(),
  {
    value: '',
    placeholder: 'Search...',
  }
);

const emit = defineEmits<{ (e: 'input', value: string): void }>();

function onInput(event: Event) {
  emit('input', (event.target as HTMLInputElement).value);
}
</script>

<template>
  <div
    class="tw:flex tw:items-center tw:gap-2 tw:px-3 tw:py-2 tw:border tw:border-black/10 tw:rounded-md tw:bg-white tw:w-full tw:sm:w-auto tw:sm:min-w-72"
  >
    <svg
      class="tw:text-secondary tw:shrink-0"
      style="width: 16px; height: 16px;"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
    <input
      :value="value"
      type="text"
      :placeholder="placeholder"
      class="tw:flex-1 tw:bg-transparent tw:outline-none tw:typography-small tw:min-w-0"
      @input="onInput"
    />
    <button
      v-if="value"
      type="button"
      class="tw:shrink-0 tw:text-secondary tw:hover:text-main tw:p-1"
      aria-label="Clear"
      @click.stop="emit('input', '')"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
    <slot name="actions" />
  </div>
</template>
